﻿import { endTestOps } from "../api/operations";
import { entityFactory } from "../hooks/useEntity";
import { ROLE } from "../Auth/useRole";
import dayjs from "dayjs";
import { shortTimeFormat } from "../helpers/timeUtils";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("end-test"),
  endpoint: "end-test",
  operations: endTestOps,
  roleView: [ROLE.ENDTEST_VIEW, ROLE.ENDTEST_RUN],
  roleAdmin: [ROLE.ENDTEST_RUN],
  initialFilter: { sortBy: "testStart", sortOrder: "descend" },
  singularName: (t) => t("End test"),
  name: (t) => t("End tests"),
  filterFormatter: ({ to, from, ...filter }: any) => {
    return {
      ...filter,
      testedTo: to ? dayjs(to).utc().format(shortTimeFormat) : undefined,
      testedFrom: from ? dayjs(from).utc().format(shortTimeFormat) : undefined,
    };
  },
});

export default conf;
